import { ECOSYSTEM_MARQUEE } from "../data/company";

// Slow editorial right-to-left marquee. Seamless: content rendered exactly twice,
// second copy aria-hidden. Pauses on hover.
export default function Marquee() {
  return (
    <section aria-label="Our railway ecosystem" className="marquee relative border-y border-navy-900/[0.08] bg-white/60 py-12">
      <p className="wrap mb-9 text-center font-mono text-[11px] uppercase tracking-[0.32em] text-slate-500">
        Our Railway Ecosystem
      </p>
      <div className="relative overflow-hidden" data-testid="ecosystem-marquee">
        <div className="marquee-track flex w-max items-center">
          {[0, 1].map((dup) => (
            <div key={dup} aria-hidden={dup === 1} className="flex items-center">
              {ECOSYSTEM_MARQUEE.map((item) => (
                <span key={`${dup}-${item}`} className="flex items-center whitespace-nowrap">
                  <span className="px-8 font-display text-2xl font-semibold uppercase tracking-wide text-slate-500 transition-colors duration-300 hover:text-brand-emeraldDark md:text-[28px]">
                    {item}
                  </span>
                  <span aria-hidden="true" className="h-2.5 w-2.5 shrink-0 rotate-45 border border-brand-emerald/60 bg-brand-emerald/15" />
                </span>
              ))}
            </div>
          ))}
        </div>
        <div className="pointer-events-none absolute inset-y-0 left-0 w-28 bg-gradient-to-r from-[#F3F7FB] to-transparent" aria-hidden="true" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-28 bg-gradient-to-l from-[#F3F7FB] to-transparent" aria-hidden="true" />
      </div>
      <p className="wrap mt-9 text-center text-[11px] leading-relaxed text-slate-700">
        Organisations shown as industry references only — no contractual relationship is implied.
      </p>
    </section>
  );
}
